// Função para detectar automaticamente a URL da API
const getApiBaseUrl = () => {
  // Se a variável de ambiente estiver definida, usar ela
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Se estiver em produção (não localhost), construir URL baseada no hostname atual
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    // Assumir que a API está no mesmo domínio na porta padrão
    return `${protocol}//${hostname}/api`;
  }

  // Desenvolvimento local
  return 'http://localhost:5000/api';
};

// Configuração da API
export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  TIMEOUT: 30000, // 30 segundos para operações normais
  SCRAPING_START_TIMEOUT: 300000, // 5 minutos para preparar lotes grandes antes de retornar o jobId
  LONG_TIMEOUT: 120000, // 2 minutos para operações longas (sync, scraping, etc)
};

export default API_CONFIG;
